import { useOnboardingChecklistPlatform } from './useOnboardingChecklistPlatform'
import * as Components from '../components'

export function useOnboardingChecklistComponent() {
  const platformProps = useOnboardingChecklistPlatform()

  // Select which result to use based on feature flag
  if (platformProps === 'loading') {
    return 'loading' as const
  }

  return <Components.OnboardingChecklistItem {...platformProps} />
}
